<template lang="pug" src="./html/ContentStage.pug"></template>

<script>

    import Vue from 'vue'
    import EventBus from './../event-bus'
    import SiteStructure from './tools/site-structure'

    // Top Level Items
    const ContentAbout = () => import(/* webpackChunkName: "about" */ './content/about/About')
    const ContentArticlesMenu = () => import(/* webpackChunkName: "articlesmenu" */ './content/articles/ArticlesMenu')
    const ContentLabs = () => import(/* webpackChunkName: "labs" */ './content/labs/Labs')
    const ContentPortfolioMenu = () => import(/* webpackChunkName: "portfoliomenu" */ './content/portfolio/PorfolioMenu')
    const ContentProjects = () => import(/* webpackChunkName: "projects" */ './content/projects/Projects')
    const ContentGallery = () => import(/* webpackChunkName: "videos" */ './content/gallery/Gallery')
    const ContentUIUX = () => import(/* webpackChunkName: "uiux" */ './content/ui-ux/UI-UX')

    Vue.component('about', ContentAbout)
    Vue.component('articles', ContentArticlesMenu)
    Vue.component('labs', ContentLabs)
    Vue.component('portfolio-menu', ContentPortfolioMenu)
    Vue.component('projects', ContentProjects)
    Vue.component('gallery', ContentGallery)
    Vue.component('uiux', ContentUIUX)

    class ContentManager {
      constructor () {
        this.data = {
          contentComponent: null
        }
      }
      changeContent (navItem) {
        if (navItem === this._currentNavItem) return
        this._currentNavItem = navItem
        if (navItem.menu) {
          if (this.data.contentComponent !== navItem.menu) {
            this.data.contentComponent = navItem.menu
            window.scrollTo(0, 0)
            this.activateLoaderAnim()
          }
        } else {
          this.data.contentComponent = navItem.content
          window.scrollTo(0, 0)
          this.activateLoaderAnim()
        }
      }
      activateLoaderAnim () {
        EventBus.dispatchEvent('LoaderAnim.ACTIVATE')
      }
    }
    const contentManager = new ContentManager()

    export default {
      name: 'ContentStage',
      beforeCreate () {
        // Initial State
        contentManager.changeContent(SiteStructure.getSelectedItem())
      },
      mounted () {
        // Events
        EventBus.$on('Nav.CHANGE', function (e) {
          contentManager.changeContent(e.navItem)
        })
      },
      data () {
        return contentManager.data
      }
    }

</script>

<style lang="sass" src="./style/ContentStage.sass"></style>
